<template>
  <div class="slider-content" ref="content">
    <div class="row">
      <div class="col-md-7 col-lg-5 offset-lg-1">
        <div class="row slider-content__sidebar">
          <div class="col-6">
            <section class="slider-content__aside slider-content__aside--left" v-html="item.left"></section>
          </div>
          <div class="col-6">
            <section class="slider-content__aside slider-content__aside--right" v-html="item.right"></section>
          </div>
        </div>
      </div>
      <div class="col-md-5 col-lg-6 order-md-first">
        <div class="slider-content__main">
          <div class="slider-content__text" v-html="item.main"></div>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          main: null,
          left: null,
          right: null
        }
      }
    }
  },
  data () {
    return {
      isVisible: false
    }
  },
  watch: {
    item () {
      this.isVisible = false
      this.setVisible()
    },
    isVisible (val) {
      if (val) this.animateIt()
      else this.cleanIt()
    }
  },
  mounted () {
    this.setVisible()
  },
  methods: {
    setVisible () {
      const self = this

      setTimeout(() => {
        self.isVisible = true
      }, 100)
    },
    cleanIt () {
      const { content } = this.$refs

      content.classList.remove('slider-content--v-content')
      content.classList.remove('slider-content--v-left')
      content.classList.remove('slider-content--v-right')
    },
    animateIt () {
      const { content } = this.$refs

      content.classList.add('slider-content--v-content')

      setTimeout(() => {
        content.classList.add('slider-content--v-left')
      }, 200)

      setTimeout(() => {
        content.classList.add('slider-content--v-right')
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
.slider-content {
  &__main,
  &__aside {
    visibility: hidden;
    opacity: 0;
  }

  &__main {
    .slider-content--v-content & {
      visibility: visible;
      opacity: 1;
      transition: opacity 100ms ease-in;
    }
  }

  &__aside--left {
    .slider-content--v-left & {
      visibility: visible;
      opacity: 1;
      transition: opacity 250ms ease-in;
    }
  }

  &__aside--right {
    .slider-content--v-right & {
      visibility: visible;
      opacity: 1;
      transition: opacity 250ms ease-in;
    }
  }

  &__sidebar {
    align-items: center;
  }

  &__aside {
    color: $theme-gray-700;
  }

  // &__aside--left {
  //   .is-visible & {
  //     visibility: visible;
  //     opacity: 1;
  //     transition: opacity 150ms ease-in;
  //     transition-delay: 100;
  //   }
  // }

  // &__aside--right {
  //   .is-visible & {
  //     visibility: visible;
  //     opacity: 1;
  //     transition: opacity 150ms ease-in;
  //     transition-delay: 10000;
  //   }
  // }

  &__text {
    @include font-size($font-size-lg);
  }
}
</style>
